module.exports = __webpack_public_path__ + "img/slider-bg1.64368a44.jpg";